import "./index.scss";
import "../../locales/i18n";

import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import ReactTooltip from "react-tooltip";

import Switch from "@/components/components/Switch";
import { SwitchValue } from "@/components/components/Switch/switch.type";
import { Close } from "@/components/icons";

interface TAvailabilityToggleProps {
    onToggleInbound: (value: SwitchValue) => void,
    onToggleAway: (value: SwitchValue) => void,
    isInboundOn: boolean,
    isAutoResponderOn?: boolean,
    onClose: () => void,
}

export const toggleTestId = "availability-toggle";
export const closeButtonTestId = "availability-close-button";

const AvailabilityToggle = ({ onToggleInbound, onToggleAway, isInboundOn, isAutoResponderOn, onClose }: TAvailabilityToggleProps): React.ReactElement => {
    const { t } = useTranslation();
    const [showTooltip, setShowTooltip] = useState(false);

    const onHover = () => {
        setShowTooltip(true);
    };
    const onHoverHide = () => {
        setShowTooltip(false);
    };


    return (
        <div className="c-availability-toggle">
            <div className="c-availability-toggle__header">
                <div className="e-heading e-heading--h1 c-availability-toggle__header-text">
                    {t("Availability")}
                </div>
                <button 
                    id={"AVAILABILITIES_BUTTON"} 
                    data-testid={closeButtonTestId} 
                    aria-label="Close Availability Menu" 
                    className="c-availability-toggle__header-close" 
                    onClick={onClose}
                    onMouseEnter={onHover}
                    onMouseLeave={onHoverHide}
                >
                    <div data-tip
                        data-for="FILTER_CLOSE_BUTTON">
                        <Close width={16} height={16} />
                    </div>
                </button>
                {showTooltip && <ReactTooltip id="FILTER_CLOSE_BUTTON" place="top" effect="solid" className="hover_tooltip">
                    {t("Close")}
                </ReactTooltip>}
            </div>
            <div className="c-availability-toggle__switch">
                <span>{t("Accept Incoming")}</span>
                <Switch
                    id={"AVAILABILITY_SWITCH"}
                    testId={toggleTestId}
                    onChange={onToggleInbound}
                    value={{ on: isInboundOn }}
                />

            </div>
            <span style={{ marginTop: "16px" }}>
                {!isInboundOn && ""}
            </span>
            {/*<div className="c-availability-toggle__switch">
                <span>{t("Enable Out-of-Office Message")}</span>
                <Switch 
                    id={"AUTORESPONDER_SWITCH"}
                    testId={toggleTestId}
                    onChange={onToggleAway} 
                    value={{on: isAutoResponderOn}}
                />
                </div>*/}
        </div>
    );
};

export default AvailabilityToggle;
